import { ISetupLicenseFormValues } from '../License.interfaces'
import { FormErrors } from "redux-form";

export default function validate (values: ISetupLicenseFormValues): FormErrors<ISetupLicenseFormValues, string> {
  const errors: FormErrors<ISetupLicenseFormValues, string> = {}
  const { body } = values

  const required = 'common.form.validation.required'

  if (!body) {
    errors.body = required
  }

  return errors
}
